<div class="summary-item">
  <span class="summary-item-label" data-hj-suppress>{{ label }}</span>
  <span class="summary-item-value">{{ checkValue(value) }}</span>
</div>